import { isAuth } from "../../helpers/cookies";
export const JOB_URL = '/job';
export const COMPANY_URL = '/company';
export const GET_JOB_MESSAGES_URL = `/company/${isAuth().company_id}/job/`
export const GET_JOB_LIST = `/listings`
export const SEND_PROOF = `/send`
export const PROOF_LOG_TABLE = `/prooflog`
export const VIEW_PROOF = `/viewproof`
export const PROOF_APPROVE = `/proof-approve`
export const PROOF_REJECT = `/proof-reject`
export const SIDEBAR_MENU_URL = `/sidebar-menu`
export const ADD_PROOF_COMMENTS_URL = `/addcomments`
export const ASSIGN_JOB_URL = `/jobs`
